import type { PhosphorIconName } from "@/shared/components/common/PhosphorIcon";

const FACILITY_ICON_NAME_BY_BACKEND_KEY: Record<string, PhosphorIconName> = {
  ATM: "CashRegister",
  Air_conditioning: "Wind",
  Air_ventilation_system: "Wind",
  Airport_reception: "AirplaneTilt",
  Area_size: "MapPinArea",
  Audio_and_video_system: "SpeakerHifi",
  Balcony: "House",
  Bathroom: "Shower",
  Bicycle: "Bicycle",
  Breakfast: "Bread",
  Buffet_breakfast: "Bread",
  Buffet_menu: "BookOpen",
  Cabinet: "Rows",
  Car_Rental_Without_Driver: "Car",
  Car_rental: "Car",
  Central_Split_Air_Conditioning: "Wind",
  Central_Video_System: "Camera",
  Child_Care_Services: "Person",
  Childcare_services: "Person",
  Clothes_hanger: "CoatHanger",
  Coffee: "Coffee",
  Coffee_maker: "Coffee",
  Coffee_shop: "Coffee",
  Commercial_Store: "Building",
  Conference_Hall: "VideoConference",
  Conference_room: "VideoConference",
  Cooking_allowed: "Cookie",
  Currency_Exchange: "Money",
  Daily_room_service: "Clipboard",
  Dedicated_play_area_for_children: "Park",
  Dining_table: "BowlFood",
  Drawer: "Rows",
  Elevator: "Elevator",
  Evaporative_cooler: "Wind",
  Fax_and_Photocopy: "Copy",
  Fan: "Fan",
  Fire_alarm: "Fire",
  Fire_extinguisher: "FireExtinguisher",
  Fire_extinguishing_system: "Fire",
  Foreign_Payment: "Money",
  Free_Parking: "Car",
  Free_Wireless_Internet: "WifiHigh",
  Free_internet: "WifiHigh",
  Furniture: "Armchair",
  Game_Center: "GameController",
  Gas_heater: "GasCan",
  Gas_stove: "Oven",
  Gym: "Barbell",
  Hair_Salon: "Scissors",
  Heating_and_cooling_system: "Thermometer",
  IP_TV: "TelevisionSimple",
  In_room_service: "HandSoap",
  Indoor_slippers: "Footprints",
  Internet_Coffee: "Coffee",
  Iranian_style_bathroom: "Bathtub",
  Iranian_style_toilet: "ToiletPaper",
  Iron: "GasCan",
  Ironing_clothes: "GasCan",
  Kitchen_utensils: "ForkKnife",
  Lake_view: "SwimmingPool",
  Laundry_Services: "WashingMachine",
  Laundry_services: "WashingMachine",
  Leisure_Tour_Services: "Sun",
  Library: "Book",
  Lobby: "Elevator",
  Locked_cabinet: "LockSimpleOpen",
  Luggage_Room: "Backpack",
  Luggage_Services: "Backpack",
  Massage: "Sparkle",
  Meeting_and_banquet_facilities: "Users",
  Meeting_room: "User",
  No_pets: "Prohibit",
  No_smoking: "CigaretteSlash",
  Number_of_Beds: "Bed",
  Number_of_Layers: "Building",
  Parking: "Garage",
  Pet_friendly: "Dog",
  Photocopy: "Copy",
  Prayer_Room: "Mosque",
  Prayer_room: "Mosque",
  Refrigerator: "ForkKnife",
  Request_for_amenities: "Park",
  Restaurant: "ForkKnife",
  Room_door_lock: "Key",
  Round_trip_service_to_the_shrine: "Bus",
  Safe_deposit_box: "ShieldCheck",
  Shoe_polishing_machine: "Footprints",
  Shop: "ShoppingBag",
  Shower: "Shower",
  Smoking_Room: "Cigarette",
  Swimming_Pool: "SwimmingPool",
  TV: "TelevisionSimple",
  Taxi_Service: "Taxi",
  Taxi_service: "Taxi",
  Tea_maker: "Coffee",
  Telephone: "Phone",
  Travel_Agency: "Park",
  Twenty_four_hour_Hour_Room_Service: "Clock",
  Twenty_four_hour_hour_service: "Clock",
  WiFi: "WifiHigh",
  Wake_up_call_service: "Alarm",
  Wardrobe: "ShirtFolded",
  Western_style_bathroom: "Bathtub",
  Western_style_toilet: "Toilet",
  hair_dryer: "HairDryer",
  safe_deposit_box: "ShieldCheck",
};

export function getPhosphorFacilityIconName(
  backendIcon: string | null | undefined,
): PhosphorIconName | undefined {
  const normalized = normalizeBackendFacilityIconKey(backendIcon);
  if (!normalized) return undefined;

  return FACILITY_ICON_NAME_BY_BACKEND_KEY[normalized];
}

function normalizeBackendFacilityIconKey(value: string | null | undefined) {
  return value?.trim().replace(/\s+/g, "_");
}
